import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as ReactRedux from 'react-redux';
import SelfServeTooltipTourConstants from 'SelfServeTooltipTour/TooltipTourConstants';
import { ElementWithTooltip } from 'DesignSystem/Tooltips';
import AnswerQuestionTooltipContent from './AnswerQuestionTooltipContent';

const ElementWithAnswerQuestionTooltip = ({
  activeTooltipIndex,
  children: recipientBuilderField,
  isTourDisplayed,
  targetElementType,
}) => {
  const tooltipClasses = classNames(
    'self-serve-recipient-preview-answer-question-tooltip',
    'recipient-preview-tour-tooltip',
    `recipient-preview-${targetElementType}-input`,
  );

  const isAnswerQuestionTooltipDisplayed = isTourDisplayed &&
    (activeTooltipIndex === SelfServeTooltipTourConstants.ANSWER_QUESTION_TOOLTIP_IDX);

  if (isAnswerQuestionTooltipDisplayed) {
    return (
      <ElementWithTooltip
        className={tooltipClasses}
        displayEvent="none"
        placement="right"
        size="lg"
        showByDefault
        showCloseButton
        targetClassName="answer-question-tooltip-target"
        targetElement={recipientBuilderField}
        tooltipId="selfServeRecipientPreviewAnswerQuestionTooltip"
      >
        <AnswerQuestionTooltipContent />
      </ElementWithTooltip>
    );
  }

  return recipientBuilderField;
};

ElementWithAnswerQuestionTooltip.propTypes = {
  activeTooltipIndex: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  isTourDisplayed: PropTypes.bool.isRequired,
  targetElementType: PropTypes.string.isRequired,
};

const mapStateToProps = ({
  TooltipTourReducer,
}) => ({
  activeTooltipIndex: TooltipTourReducer.activeTooltipIndex,
  isTourDisplayed: TooltipTourReducer.isTourDisplayed,
});

export default ReactRedux.connect(
  mapStateToProps,
)(ElementWithAnswerQuestionTooltip);



// WEBPACK FOOTER //
// ./src-react/SelfServeRecipientBuilder/components/ElementWithAnswerQuestionTooltip.jsx